export const eulerSwapAddresses = {
  eulerSwapV1Factory: "0x3e378e5E339DF5e0Da32964F9EEC2CDb90D28Cc7",
  eulerSwapV1Implementation: "0x16BCa43290b77409e6D1c92B929f7A09C0E4EE86",
  eulerSwapV1Periphery: "0xa8826Bb29f875Db4c4b482463961776390774525",
} as const
